import { useNotificationStore } from '@/store/storeNotificationSnackbar';
import { useBackendHealthStore, classifyTransientError } from '@/store/storeBackendHealth';

function getNotificationStore() {
    return useNotificationStore();
}

/** Report a caught exception to the operator.  Transient
 *  backend/network failures (HTTP 4xx/5xx, offline, timeouts) route
 *  to the status-bar backend-health indicator — a toast popup for a
 *  self-healing hiccup is more disruptive than useful.  Real
 *  application errors (unauth, validation, logic bugs) still trigger
 *  the toast so the operator can see them properly. */
export function alertException(e, description: string) {
    const kind = classifyTransientError(e);
    if (kind) {
        useBackendHealthStore().report(description, kind);
        return;
    }
    getNotificationStore().setNotificationError(description, e);
}

export function alertSuccess(message) {
    getNotificationStore().setNotificationSuccess(message);
}
